import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QueueListComponent } from './components/queue-list/queue-list.component';
import { QueueFormComponent } from './components/queue-form/queue-form.component';
import { QueueDto } from './models/queue.dto';

type ViewMode = 'list' | 'form';

@Component({
  selector: 'app-queue-management',
  standalone: true,
  imports: [CommonModule, QueueListComponent, QueueFormComponent],
  templateUrl: './queue-management.component.html',
})
export class QueueManagementComponent {
  viewMode: ViewMode = 'list';
  selectedQueueId: number | null = null;
  reloadVersion = 0;

  openNewQueue(): void {
    this.selectedQueueId = null;
    this.viewMode = 'form';
  }

  openEditQueue(queue: QueueDto): void {
    this.selectedQueueId = queue.id;
    this.viewMode = 'form';
  }

  onSaved(): void {
    this.viewMode = 'list';
    this.reloadVersion++;
  }

  onCancelled(): void {
    this.viewMode = 'list';
  }
}
